import React from 'react';
import { styled, makeStyles, Button, TextField, Paper } from '@material-ui/core';
import { Trans, t } from '@lingui/macro';


export default function DiscountForm(props) {
    const { code, status, message, onSubmit, onChange, onDelete } = props;

    const c = useStyles();

    const handleCodeChange = (e) => {
        let newValue = e.target.value;
        onChange(newValue.slice(0, 50)); // Limit to 50 characters
    };


    return (
        <Container>
            <InputBox
                label={t`Discount Code`}
                value={code}
                onChange={handleCodeChange}
                error={status === 'error'}
                helperText={message}
                InputProps={status === 'success' ? {classes:{root: c.inputRoot}, readOnly: true} : undefined}
                InputLabelProps={status === 'success' ? {classes:{root: c.inputLabelRoot}} : undefined}
                FormHelperTextProps={status === 'success' ? {classes:{root: c.formHelperTextRoot}} : undefined}
            />
            {status === 'success' ? (
                <RemoveButton size='small' variant='outlined' onClick={onDelete}><Trans>Remove</Trans></RemoveButton>
            ) : (<>
                {(status === 'loading' || code.length === 0)
                    ? <DisabledButton size='small' variant='outlined' disabled><Trans>Apply</Trans></DisabledButton>
                    : <ApplyButton size='small' color='primary' variant='contained' onClick={onSubmit}><Trans>Apply</Trans></ApplyButton>
                }
            </>)}
        </Container>
    )
}

const useStyles = makeStyles(theme => ({
    inputRoot: {
      '& fieldset': {
        borderColor: theme.palette.success.main,
      }
    },
    inputLabelRoot: {
        color: theme.palette.success.main,
    },
    formHelperTextRoot: {
        color: theme.palette.success.main,
    },
  }));

const Container = styled(Paper)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: theme.spacing(10),
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.spacing(2),
}));

const InputBox = styled(TextField)(({ theme }) => ({}));
InputBox.defaultProps = {
    size: 'small',
    variant: 'outlined',
    color: 'secondary',
    fullWidth: true,
}

const ApplyButton = styled(Button)(({ theme }) => ({
    height: theme.spacing(5),
    marginLeft: theme.spacing(1)
}));
const DisabledButton = styled(Button)(({ theme }) => ({
    height: theme.spacing(5),
    marginLeft: theme.spacing(1)
}));
const RemoveButton = styled(Button)(({ theme }) => ({
    height: theme.spacing(5),
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1)
}));